"use strict";

var Tooltip = require("app/shared/components/Tooltip/tooltip");
var Warning = require("app/screens/Pricing/components/PlanSelector/warning");
var Button = require("app/shared/components/Button/button");

var config = require("app/util/config/config");
var TRIAL_DAYS = config.app.trialDays;

var PlanCardProButton = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    subscriptionState: React.PropTypes.string,
    accountUsers: React.PropTypes.number,
    currentPlan: React.PropTypes.object,
    selectedPlan: React.PropTypes.object.isRequired,
    expired: React.PropTypes.bool,
    trial: React.PropTypes.string
  },

  getButtonRule: function() {
    if (this.props.subscriptionState == null) {
      return ButtonRules.guestUser();
    } else if(["assinante", "cancelada"].indexOf(this.props.subscriptionState) > -1) {
      return ButtonRules.customerUser(this.props.accountUsers,
                                      this.props.currentPlan,this.props.selectedPlan, this.props.hasPaidTransaction,
                                      this.props.teamSize);
    } else if(this.props.subscriptionState == "trial") {
      return ButtonRules.trialUser(this.props.expired, this.props.accountUsers,
                                    this.props.currentPlan, this.props.selectedPlan, this.props.teamSize);
    } else if(this.props.subscriptionState == "gratuita") {
      return ButtonRules.freeUser(this.props.trial, this.props.accountUsers,
                                    this.props.selectedPlan);
    }
  },
  render: function() {
    var buttonRule = this.getButtonRule();
    return (
      <div className="mt-50 mb-50">
        <ButtonFactory buttonRule={buttonRule} selectedPlan={this.props.selectedPlan}
                        accountUsers={this.props.accountUsers} />
      </div>
    );
  }
});

function canShowTrialRequest(selectedPlan, selectedPlanVariation, accountUsers, hasPaidTransaction, teamSize){
  var reachedMaxUsers = selectedPlan.maxUsers < accountUsers;
  var validTeamSize = Boolean(teamSize) && !["1 pessoa", "2 pessoas", "3 pessoas"].includes(teamSize);

  return (!reachedMaxUsers && selectedPlan.maxUsers <= 3 && validTeamSize && selectedPlanVariation < 0 && !hasPaidTransaction);
}

var ButtonRules = {
  guestUser: function guestUser(){
    return "guest-start-trialPlan";
  },
  customerUser: function customerUser(accountUsers, currentPlan, selectedPlan, hasPaidTransaction, teamSize) {
    var reachedMaxUsers = selectedPlan.maxUsers < accountUsers;
  
    if(currentPlan) {
      var currentPlanMaxUsers = getPlanMaxUsers(currentPlan);
      var selectedPlanVariation = getSelectedPlanVariation(selectedPlan, currentPlanMaxUsers);

      if (canShowTrialRequest(selectedPlan, selectedPlanVariation, accountUsers, hasPaidTransaction, teamSize)){
        return "plan-downgrade-request";
      }

      if(selectedPlanVariation == 0){
        return "renew-plan";
      } else if (selectedPlanVariation > 0) {
        return "raise-plan";
      } else if(selectedPlanVariation < 0) {
        if (reachedMaxUsers) {
          return "disabled-user-overload";
        } else {
          return "downgrade-plan";
        }
      }
    } else {
      if (reachedMaxUsers) {
        return "disabled-user-overload";
      } else {
        return "get-plan";
      }
    }
  },
  trialUser: function trialUser(expired, accountUsers, currentPlan, selectedPlan, teamSize) {
    var currentPlanMaxUsers = getPlanMaxUsers(currentPlan);
    var selectedPlanVariation = getSelectedPlanVariation(selectedPlan, currentPlanMaxUsers);
    var reachedMaxUsers = selectedPlan.maxUsers < accountUsers

    if (canShowTrialRequest(selectedPlan, selectedPlanVariation, accountUsers, false, teamSize)){
      return "plan-downgrade-request";
    }

    if(expired || selectedPlanVariation == 0) {
      return "get-plan";
    } else if (selectedPlanVariation > 0) {
      return "raise-plan-freely";
    } else if (selectedPlanVariation < 0) {
      if (reachedMaxUsers) {
        return "disabled-user-overload-freely";
      } else {
        return "downgrade-plan-freely";
      }
    }
  },
  freeUser: function freeUser(trial, accountUsers, selectedPlan) {

    if(selectedPlan.maxUsers >= accountUsers){
      if (trial == "inativada"){
        return "start-trialPlan";
      } else if (trial == "realizada") {
        return "get-plan";
      }
    } else {
      return "disabled-user-overload";
    }
  }
};

var getPlanMaxUsers = function getPlanMaxUsers(plan){
  return (plan ? plan.maxUsers : 1);
};

var getSelectedPlanVariation = function getSelectedPlanVariation(selectedPlan, currentPlanMaxUsers){
  var selectedPlanMaxUsers = (selectedPlan ? selectedPlan.maxUsers : 1);
  return selectedPlanMaxUsers - currentPlanMaxUsers;
};

var ButtonFactory = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function(){
    var pid = this.props.selectedPlan.planId;
    if(this.props.buttonRule == "start-trialPlan") {
      var buttonText = this.getIntlMessage("pricing.buttons.try_free");
      var formattedButtonText = this.formatMessage(buttonText, {days: TRIAL_DAYS});
      var buyNow = this.getIntlMessage("pricing.buttons.buy_now");
      return (
        <div>
          <Button type="success"
            href={{url: "/src/php/sistema/http/obj/Cliente/ativar-trial.php?pid=" + pid, name: "_top"}}>
            <span>{formattedButtonText.toUpperCase()}</span>
          </Button>
          <div>
            <a className="fs-16 planCard-linkColor" target="_top"
              href={"/sistema/minha-conta/contratar-agora.php?pid=" + pid}>
              {buyNow.toLowerCase()}
            </a>
          </div>
        </div>
      );
    } else if(this.props.buttonRule == "guest-start-trialPlan"){
      var buttonText = this.getIntlMessage("pricing.buttons.try_free");
      var formattedButtonText = this.formatMessage(buttonText, {days: TRIAL_DAYS});
      var buyNow = this.getIntlMessage("pricing.buttons.buy_now");
      return (
        <div>
          <Button type="success" href={{url: "/cadastro?pid=" + pid, name: "_top"}}>
            <span>{formattedButtonText.toUpperCase()}</span>
          </Button>
          <div>
            <a className="fs-16 planCard-linkColor" target="_top"
              href={"/sistema/minha-conta/contratar-agora.php?pid=" + pid}>
              {buyNow.toLowerCase()}
            </a>
          </div>
        </div>
      );
    } else if(this.props.buttonRule == "renew-plan"){
      var buttonText = this.getIntlMessage("pricing.buttons.renew_plan");
      return (
        <Button type="success" href={{url: "/sistema/minha-conta/simulacao-plano.php?pid=" + pid, name: "_top"}}>
          <span>{buttonText.toUpperCase()}</span>
        </Button>
      );
    } else if(this.props.buttonRule == "raise-plan"){
      var buttonText = this.getIntlMessage("pricing.buttons.raise_plan");
      return (
        <Button type="success" href={{url: "/sistema/minha-conta/simulacao-plano.php?pid=" + pid, name: "_top"}}>
          <span>{buttonText.toUpperCase()}</span>
        </Button>
      );
    } else if(this.props.buttonRule == "disabled-user-overload"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan");
      var message = this.getIntlMessage("pricing.warning.user_overflow");
      var usersVariation = this.props.accountUsers - this.props.selectedPlan.maxUsers;
      var formattedMessage = this.formatMessage(message, {users: usersVariation});
      return (
        <div className="mt--25 mb--17">
          <Tooltip bottom title={formattedMessage}>
            <Button type="default" disabled>
              <span>{buttonText.toUpperCase()}</span>
            </Button>
          </Tooltip>
          <Warning text={formattedMessage} warningLink="/sistema/usuarios/" />
        </div>
      );
    } else if(this.props.buttonRule == "disabled-user-overload-freely"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan_freely");
      var message = this.getIntlMessage("pricing.warning.user_overflow");
      var usersVariation = this.props.accountUsers - this.props.selectedPlan.maxUsers;
      var formattedMessage = this.formatMessage(message, {users: usersVariation});
      return (
        <div className="mt--25 mb--17">
          <Tooltip bottom title={formattedMessage}>
            <Button type="default" disabled>
              <span>{buttonText.toUpperCase()}</span>
            </Button>
          </Tooltip>
          <Warning text={formattedMessage} warningLink="/sistema/usuarios/" />
        </div>
      );
    } else if(this.props.buttonRule == "downgrade-plan"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan");
      return (
        <Button type="warning" href={{url: "/sistema/minha-conta/simulacao-plano.php?pid=" + pid, name: "_top"}}>
          <span>{buttonText.toUpperCase()}</span>
        </Button>
      );
    } else if(this.props.buttonRule == "get-plan"){
      var buttonText = this.getIntlMessage("pricing.buttons.subscribe");
      return (
        <Button type="success" href={{url: "/sistema/minha-conta/simulacao-plano.php?pid=" + pid, name: "_top"}}>
          <span>{buttonText.toUpperCase()}</span>
        </Button>
      );
    } else if(this.props.buttonRule == "raise-plan-freely"){
      var buttonText = this.getIntlMessage("pricing.buttons.raise_plan_freely");
      return (
        <Button type="success"
                       href={{url: "/src/php/sistema/http/obj/Cliente/alterar-plano.php?pid=" + pid, name: "_top"}}>
          <span>{buttonText.toUpperCase()}</span>
        </Button>
      );
    } else if(this.props.buttonRule == "downgrade-plan-freely"){
      var buttonText = this.getIntlMessage("pricing.buttons.downgrade_plan_freely");
      return (
        <Button type="warning"
                       href={{url: "/src/php/sistema/http/obj/Cliente/alterar-plano.php?pid=" + pid, name: "_top"}}>
          <span>{buttonText.toUpperCase()}</span>
        </Button>
      );
    } else if (this.props.buttonRule == "plan-downgrade-request"){
      var buttonText = this.getIntlMessage("pricing.buttons.plan_downgrade_request");
      return (
        <Button type="warning"
                       href={{url: "/src/php/sistema/http/obj/Cliente/solicitar-reducao-trial.php?pid=" + pid, name: "_top"}}>
          <span>{buttonText.toUpperCase()}</span>
        </Button>
      );
    }
  }
});

module.exports = PlanCardProButton;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-pro-button.jsx